<template>
  <li>
    <div>
      <input
        :id="'filter-' + item.slug"
        type="checkbox"
        :value="item.slug"
        :disabled="item.count === 0"
        :aria-disabled="item.count === 0"
        :checked="item.slug === activeItem"
        @change="toggleFilter($event.target.checked ? item.slug : '')"
      />
      <label :for="'filter-' + item.slug">
        <span :class="{ caret: item.list && item.list.length > 0 }">{{ item.name }}&nbsp;</span>
        <span class="label pull-right">{{ numberWithCommas(item.count) }}</span>
      </label>
    </div>

    <template v-if="item.list && item.list.length > 0">
      <ul v-show="isOpen" class="link-list">
        <resource-list-filters-child
          v-for="subitem in item.list"
          :key="subitem.slug"
          :active-item="activeItem"
          :category="category"
          :item="subitem"
          @toggle-filter="toggleFilter"
        />
      </ul>
    </template>
  </li>
</template>

<script>
import { numberWithCommas } from '~/utils/formatStrings';

/* List item of child categories
 * Pass the activeItem recursively down the list items
 *
 * @parent: /components/resource/ResourceListFilters
 * @requests:
 * @events: toggle-filter
 * @props: String activeItem, String category, Array items
 * @components: ResourceListFiltersChild
 * @methods: toggleFilter
 */

// Recursive

export default {
  name: 'ResourceListFiltersChild',
  components: {
    ResourceListFiltersChild: () => import('~/components/resource/ResourceListFiltersChild.vue'),
  },
  props: {
    activeItem: {
      type: String,
      default: null,
    },
    category: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    if (this.item.slug === this.activeItem) {
      this.toggleFilter(this.activeItem);
    }
  },
  methods: {
    numberWithCommas,
    toggleFilter(item) {
      // Issue here with isOpen setting to false recursively up the chain - should only close one level up
      this.isOpen = !!item;
      this.$emit('toggle-filter', item, this.category);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~/assets/scss/components/_filter.scss';
</style>
